import { useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { RegionType } from "~pages/Leagues/LeagueListPage/enums/regionType.ts";
import type { LabelValue } from "~types/labelValue.ts";
import CustomSelect from "../CustomSelect";

type Props = {
  className?: string;
  disabled?: boolean;
  placeholder?: string;
  multiple?: boolean;
  value?: LabelValue | LabelValue[];
  onChange?: (value: LabelValue | LabelValue[] | undefined) => void;
};

const SelectRegionType = (props: Props) => {
  const { className, disabled, multiple } = props;
  const options = useMemo(
    () =>
      Object.values(RegionType).map((value) => ({
        value,
        label: value,
      })),
    [],
  );

  return (
    <CustomSelect
      style={{ minWidth: "160px" }}
      value={props.value}
      showSearch
      onChange={(_, option) => {
        if (multiple) {
          props.onChange?.(option as LabelValue[]);
        } else {
          props.onChange?.(option as LabelValue);
        }
      }}
      options={options}
      placeholder={props.placeholder || <FormattedMessage id="regionType" />}
      allowClear
      className={className}
      disabled={disabled}
      mode={multiple ? "multiple" : undefined}
    />
  );
};

export default SelectRegionType;
